import { render, staticRenderFns } from "./optimise-prices-toggle.vue?vue&type=template&id=1374b7e7&scoped=true"
import script from "./optimise-prices-toggle.vue?vue&type=script&lang=js"
export * from "./optimise-prices-toggle.vue?vue&type=script&lang=js"
import style0 from "./optimise-prices-toggle.vue?vue&type=style&index=0&id=1374b7e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1374b7e7",
  null
  
)

export default component.exports